// extracted by mini-css-extract-plugin
export default {"notificationContent":"styles_notificationContent__zOPAX","drawerMode":"styles_drawerMode__YIL1m"};